function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.7,
    height: 195.7,
    viewBox: "0 0 195.7 195.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.85,195.7A97.85,97.85,0,1,1,195.7,97.85,97.85,97.85,0,0,1,97.85,195.7Z",
    transform: "translate(0 0)",
    style: {
      fill: "#ed2024"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.49,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.42,
    cy: 71.74,
    rx: 13.49,
    ry: 17.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,107.85h-.2c-41.4.13-58.85,43.16-59.58,45l8.29,3.27c.16-.39,16-39.29,51.39-39.36s51.23,39,51.39,39.36l8.29-3.27C156.7,151,139.25,108,97.85,107.85Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSelected);
export default __webpack_public_path__ + "static/media/sad-selected.f4273ce116eeec16e0aaae01a75512a3.svg";
export { ForwardRef as ReactComponent };